import Vue from 'vue';

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = event => {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

Vue.directive('onscrollto', {
  bind(el, { value, modifiers }) {
    const isObject = typeof value === 'object';
    const onScrollTo = isObject ? value.handler : value;
    const offset = isObject ? value.offset || 1 : 1;

    const unbindAfterOnce = () => {
      window.removeEventListener('liteScroll', el._onScroll);
      el._onScroll = undefined;
    };

    const onScroll = () => {
      if (el.getBoundingClientRect().top > window.innerHeight * offset) return;

      onScrollTo();

      if (modifiers.once) unbindAfterOnce();
    };

    el._onScroll = onScroll;
    window.addEventListener('liteScroll', el._onScroll);

    onScroll();
  },
  unbind(el) {
    window.removeEventListener('liteScroll', el._onScroll);
    el._onScroll = undefined;
  },
});

Vue.directive('scroll-to', {
  bind(el, binding, vnode) {
    el.scrollToEvent = event => {
      event.preventDefault();
      const id = el.getAttribute('href');
      const target = document.querySelector(id);
      const header = document.querySelector('.pageHeader');
      window.scrollTo({
        top: target.offsetTop - (header.clientHeight + 15),
        left: 0,
        behavior: 'smooth',
      });
    };
    el.addEventListener('click', el.scrollToEvent);
  },
  unbind(el) {
    el.removeEventListener('click', el.scrollToEvent);
  },
});
